import { render, staticRenderFns } from "./AddRegisteredChildrenControl.vue?vue&type=template&id=5bad4466&"
import script from "./AddRegisteredChildrenControl.vue?vue&type=script&lang=ts&"
export * from "./AddRegisteredChildrenControl.vue?vue&type=script&lang=ts&"
import style0 from "./AddRegisteredChildrenControl.vue?vue&type=style&index=0&id=5bad4466&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports